import {
  CloseOutlined,
  FolderFilled,
  HddOutlined,
  PushpinOutlined,
} from '@ant-design/icons';
import { Button, Tooltip, Typography } from 'antd';
import React from 'react';
import { ROOT_LABEL } from './AddressBar';
import { toWindowsPath } from './mediaPath';

const itemStyle = (isActive) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: '100%',
  minHeight: 34,
  padding: '0 4px 0 8px',
  border: 0,
  borderRadius: 6,
  background: isActive ? '#e6f4ff' : 'transparent',
  cursor: 'pointer',
  textAlign: 'left',
  fontSize: 14,
  color: '#1f1f1f',
});

// Deux raccourcis peuvent porter le même nom (« Ambiance ») : on affiche alors
// le dossier parent pour les distinguer.
const withLabels = (shortcuts) => {
  const names = shortcuts.map((path) => path.split('/').pop());
  return shortcuts.map((path, index) => {
    const parts = path.split('/');
    const isDuplicate =
      names.filter((name) => name === names[index]).length > 1;
    return {
      path,
      label: names[index],
      parent: isDuplicate && parts.length > 1 ? parts[parts.length - 2] : null,
    };
  });
};

// Volet « Accès rapide » à gauche, comme dans l'explorateur Windows.
const QuickAccessPane = ({ shortcuts, currentPath, onNavigate, onUnpin }) => (
  <nav
    aria-label="Accès rapide"
    style={{
      width: 232,
      flexShrink: 0,
      borderRight: '1px solid #f0f0f0',
      padding: '8px',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    <Typography.Text
      type="secondary"
      strong
      style={{
        fontSize: 12,
        padding: '4px 8px 8px',
        textTransform: 'uppercase',
      }}
    >
      Accès rapide
    </Typography.Text>
    {shortcuts.length === 0 && (
      <Typography.Text
        type="secondary"
        style={{ fontSize: 13, padding: '0 8px 8px' }}
      >
        <PushpinOutlined aria-hidden /> Épinglez un dossier (bouton en haut ou
        clic droit) pour le retrouver ici.
      </Typography.Text>
    )}
    {withLabels(shortcuts).map(({ path, label, parent }) => (
      <div key={path} style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title={toWindowsPath(path)} placement="right">
          <button
            type="button"
            onClick={() => onNavigate(path)}
            aria-current={path === currentPath ? 'page' : undefined}
            style={itemStyle(path === currentPath)}
          >
            <FolderFilled aria-hidden style={{ color: '#faad14' }} />
            <span
              style={{
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {label}
              {parent && (
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {` (${parent})`}
                </Typography.Text>
              )}
            </span>
          </button>
        </Tooltip>
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined aria-hidden />}
          aria-label={`Retirer ${label} de l'accès rapide`}
          onClick={() => onUnpin(path)}
        />
      </div>
    ))}
    <div style={{ height: 1, background: '#f0f0f0', margin: '8px 4px' }} />
    <button
      type="button"
      onClick={() => onNavigate('')}
      aria-current={currentPath === '' ? 'page' : undefined}
      style={itemStyle(currentPath === '')}
    >
      <HddOutlined aria-hidden style={{ color: '#595959' }} />
      {ROOT_LABEL}
    </button>
  </nav>
);

export default QuickAccessPane;
